module.exports = __webpack_public_path__ + "6d6f351756b2b2e00ea41da505047170.fbx";